const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Assessments Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('ApiApplications', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  return $resource(appConfiguration.apiUrl + '/v3/api-applications/:subresource/:subname', null, {
    find: {params: {subresource: ''}, method: 'GET', isArray: true},
    expose: {params: {subresource: '', subname: 'expose'}, method: 'GET', isArray: false},
    create: {params: {subresource: ''}, method: 'POST', isArray: false},
    remove: {params: {subresource: ''}, method: 'DELETE', isArray: false}
  });
}]);
